import React, { type ReactElement } from 'react'

import { Container } from '../../../../routes/app/transactions/[id]/print/Container'

export const buildAppTransactionIdPrintPath = (id: string | number): string => `/app/transactions/${id}/print`

function AppTransactionIdPrintPath (): ReactElement {
  return <Container />
}

AppTransactionIdPrintPath.getLayout = function getLayout (page: ReactElement) {
  return (
    <>
      {page}
    </>
  )
}
export default AppTransactionIdPrintPath
